import BaseService from './baseService';

class Items extends BaseService {
	async getRiwayatProduk(id, opts = {}) {
    this.endPoint = '/items-pos/'+id;
		return this.get(opts);
  }
}

export default new Items();